import { EXPLORE_SORT_QUERY } from "enums/new-explore/explore-sort";
import { EXPLORE_COST } from "enums/new-explore/explore-cost";
import { EXPLORE_STATUS } from "types/api/explore";

type BannerConfig = {
  image: string;
  title: React.ReactNode;
  color: string;
  url: string;
};

export const banners: BannerConfig[] = [
  {
    image:
      "https://faradars.org/wp-content/uploads/2023/12/25/cover-end-yellow.png",
    title: (
      <p className="text-zinc-800 lg:text-[32px] text-xl font-bold">
        جدیدترین{" "}
        <span className="text-base lg:text-xl leading-6">آموزش‌ها</span>
      </p>
    ),
    color: "bg-[#FEE5A5]",
    url: `/explore?sort=${EXPLORE_SORT_QUERY.NEWEST}&cost=${EXPLORE_COST.NOT_FREE}`,
  },
  {
    image:
      "https://faradars.org/wp-content/uploads/2023/12/25/cover-end-blue.png",
    title: (
      <p className="text-zinc-800 text-base lg:text-xl font-bold md:leading-[30px] leading-6">
        آموزش‌های{" "}
        <span className="lg:text-[32px] text-xl leading-10">پر‌مخاطب</span>
      </p>
    ),
    color: "bg-[#D4E9FE]",
    url: `/explore?publish_status=${EXPLORE_STATUS.PUBLISHED}&sort=${EXPLORE_SORT_QUERY.POPULAR}&cost=${EXPLORE_COST.NOT_FREE}`,
  },
];
